export const emailValidations = ($http: HttpApi) => ({
  create: (tenantSlug: string, params: HttpParams['body']) => $http.$post(`/public/workspaces/${tenantSlug}/email_validations`, { body: params }),
});
